import React from 'react';

import { useAdminCompanies } from '../hooks';

export type WithAdminCompaniesProps = ReturnType<typeof useAdminCompanies>;

/**
 * @description This component has built on top `useAdminCompanies`.
 * @param WrappedComponent
 */
export function withAdminCompanies<T extends WithAdminCompaniesProps>(
    WrappedComponent: React.ComponentType<T>
) {
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || 'Component';

    const ComponentWithAdminCompanies = (
        props: Omit<T, keyof WithAdminCompaniesProps>
    ) => {
        const adminCompaniesProps = useAdminCompanies();

        return (
            <WrappedComponent
                {...adminCompaniesProps}
                {...(props as T)}
            />
        );
    };

    ComponentWithAdminCompanies.displayName = `withAdminCompanies(${displayName})`;

    return ComponentWithAdminCompanies;
}
